var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "9" } },
            [_c("sign-up", { attrs: { "referrer-id": _vm.referrerId } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }